import type { SavedQuery } from '@/sections/insights/queryBuilder/types/SavedQuery';
import { generateUuid } from '@/utils/uuid.util';

import { NewQueryModal } from './NewQueryModal';

/**
 * Backward-compatible export for DuplicateQueryModal
 * Wraps NewQueryModal with mode='duplicate'
 */
export interface DuplicateQueryModalProps {
  isOpen: boolean;
  onClose: () => void;
  originalQuery: SavedQuery;
}

export const DuplicateQueryModal = ({
  isOpen,
  onClose,
  originalQuery,
}: DuplicateQueryModalProps) => {
  const duplicateQuery: SavedQuery = {
    ...originalQuery,
    id: generateUuid(),
    name: `${originalQuery.name} (Duplicate)`,
  };

  return (
    <NewQueryModal
      key={isOpen.toString()}
      isOpen={isOpen}
      onClose={onClose}
      originalQuery={duplicateQuery}
    />
  );
};
